/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Button } from 'design-react-kit/dist/design-react-kit';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Icon } from '@italia/components/ItaliaTheme';
import Background from './Background';

const navigate = (text) => {
  window.open(
    `https://sol.unibo.it/SebinaOpac/query/${text}?context=catalogo`,
    '_blank',
  );
};

const Body = ({ block, sections }) => {
  const history = useHistory();
  const [inputText, setInputText] = useState('');

  const handleClick = (link) => {
    history.push(flattenToAppURL(link['@id']));
  };

  const intl = useIntl();
  moment.locale(intl.locale);
  return (
    <div className="public-ui searchSections ">
      <Background image={block.image} />
      <div className="container">
        <div className="searchContainer d-flex w-100">
          <h2 className="mb-4">{block.title}</h2>
          <div className="searchbar lightgrey-bg-c2 shadow-sm rounded d-flex w-100">
            <input
              className="inputSearch lightgrey-bg-c2"
              type="text"
              placeholder={block.placeholder}
              onChange={(e) => setInputText(e.currentTarget.value)}
              onKeyDown={(e) =>
                e.key === 'Enter' ? navigate(inputText) : null
              }
            ></input>
            <button
              className="rounded-right"
              onClick={(e) => navigate(inputText)}
            >
              <Icon icon="it-search" padding={false} size="sm" />
            </button>
          </div>
          <div className="buttonsContainer mt-2 d-flex">
            {block.links?.map((link, index) => {
              return (
                <Button
                  color="primary"
                  tag="button"
                  size="sm"
                  key={index}
                  onClick={() => handleClick(link)}
                >
                  {link.title}
                </Button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  block: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
